import React from "react";
import Layout from "../components/Layout";
import TeamBoard from "../components/team/TeamBoard";

function Team() {
  return (
    <Layout>
      <TeamBoard />
    </Layout>
  );
}

export default Team;
